// extracted by mini-css-extract-plugin
export default {"container":"AboutUs_container__Ixb9t","title":"AboutUs_title__DNT6b","heading":"AboutUs_heading__zcQnO","list":"AboutUs_list__MIreT"};